import { lazy } from 'react';

export const StationPage = lazy(() => import('./StationPage'));
